{
  "id": 7819581,
  "numericId": 7819581,
  "collectionId": 799,
  "status": "ACTIVE",
  "sessionTime": 0,
  "startTime": "2026-05-20T06:08:40.381Z",
  "examBreak": null,
  "timeAllocation": null,
  "progressList": [],
  "sessionItems": [
    {
      "id": 104845,
      "versionId": 1,
      "blockId": null,
      "type": "MCQ",
      "parentId": null,
      "recordType": "ITEM",
      "content": {
        "stem": {
          "text": "A student with an Individualized Education Program (IEP) is scheduled to take a standardized test with a learning specialist. In a private conversation with the student’s teacher, the learning specialist shares that the student’s parent has contacted her multiple times about the test and that she feels pressured to coach the student. The teacher wonders whether there is any obligation to respond to this situation.\n\nWhich of the following guidelines best states an ethical obligation the teacher has as a professional educator in the situation?"
        }
      },
      "metadata": {
        "type": "MCQ",
        "ui_type": "pre-test post-test question",
        "language": "en-US",
        "position": 1,
        "sourceId": 9001
      },
      "scoring": {
        "type": "EXACT_MATCH",
        "points": 1,
        "answerKey": [
          {
            "points": 0,
            "choiceId": "23d43102-1f9e-4d06-b3aa-7c3b7277367a",
            "isCorrect": false
          },
          {
            "points": 0,
            "choiceId": "05ab19d5-51ad-4f79-8660-482b14c8a9e3",
            "isCorrect": false
          },
          {
            "points": 1,
            "choiceId": "47513e4c-74b2-4d3f-80df-f553cdeac247",
            "isCorrect": true
          }
        ],
        "selection": {
          "max": 1,
          "min": 1
        }
      },
      "feedback": [
        {
          "type": "STATIC",
          "choiceId": "47513e4c-74b2-4d3f-80df-f553cdeac247",
          "detailed": {
            "text": "Professional codes of ethics emphasize that educators have a responsibility to take reasonable steps when they become aware of potential ethical concerns, particularly when there is pressure that may compromise professional judgment or standards. In this scenario, the learning specialist’s concern about being pressured to coach a student signals a possible ethical conflict, and the teacher has an obligation to respond appropriately rather than remain passive."
          },
          "language": "en-US"
        }
      ],
      "response": {
        "type": "SINGLE_CHOICE",
        "choices": [
          {
            "id": "23d43102-1f9e-4d06-b3aa-7c3b7277367a",
            "text": "Ethical dilemmas involving an individual educator’s actions should be left to that educator to resolve independently.",
            "numFirstSelections": 0
          },
          {
            "id": "05ab19d5-51ad-4f79-8660-482b14c8a9e3",
            "text": "Private conversations between educators should be kept in confidence at all times as a matter of professional respect and individual rights.",
            "numFirstSelections": 0
          },
          {
            "id": "47513e4c-74b2-4d3f-80df-f553cdeac247",
            "text": "Educators should take reasonable steps to resolve conflicts between ethical obligations and the implicit or explicit demands someone makes.",
            "numFirstSelections": 0
          }
        ],
        "shuffle": false,
        "instruction": "Choose the best answer from the following options."
      },
      "tags": [
        {
          "id": 38014,
          "label": "Pre Test MCQs",
          "title": "Pre Test MCQs",
          "type": "Practice Test",
          "code": null,
          "displayType": [
            "Display",
            "Filter",
            "Progress"
          ]
        }
      ],
      "score": null
    },
    {
      "id": 104846,
      "versionId": 1,
      "blockId": null,
      "type": "MCQ",
      "parentId": null,
      "recordType": "ITEM",
      "content": {
        "stem": {
          "text": "Mr. Wilson, a social studies teacher, is preparing to teach a required unit on the Holocaust. His class includes students with diverse emotional and cultural backgrounds, including some students who may find the content distressing.\n\nWhich of the following actions best reflects an ethical commitment to making the curriculum accessible while maintaining equitable learning expectations?"
        }
      },
      "metadata": {
        "type": "MCQ",
        "ui_type": "pre-test post-test question",
        "language": "en-US",
        "position": 2,
        "sourceId": 9002
      },
      "scoring": {
        "type": "EXACT_MATCH",
        "points": 1,
        "answerKey": [
          {
            "points": 0,
            "choiceId": "e9591005-7184-49ad-8bd6-d44d839b8101",
            "isCorrect": false
          },
          {
            "points": 0,
            "choiceId": "329b8234-3642-4e88-9861-c7cd83148338",
            "isCorrect": false
          },
          {
            "points": 1,
            "choiceId": "7a0bd3e8-f2c7-4a33-ac39-ec3b0732c1d8",
            "isCorrect": true
          }
        ],
        "selection": {
          "max": 1,
          "min": 1
        }
      },
      "feedback": [
        {
          "type": "STATIC",
          "choiceId": "7a0bd3e8-f2c7-4a33-ac39-ec3b0732c1d8",
          "detailed": {
            "text": "By carefully selecting the materials and activities, Mr. Wilson will be more effective in teaching his students difficult content. Since the unit is part of the required curriculum, Mr. Wilson would be violating school policy by not teaching it to his students, as well as undercutting the quality of their educational experience."
          },
          "language": "en-US"
        }
      ],
      "response": {
        "type": "SINGLE_CHOICE",
        "choices": [
          {
            "id": "e9591005-7184-49ad-8bd6-d44d839b8101",
            "text": "He omits the Holocaust unit to avoid causing distress to students.",
            "numFirstSelections": 0
          },
          {
            "id": "329b8234-3642-4e88-9861-c7cd83148338",
            "text": "He allows students who find the content distressing to opt out and complete an alternative unit.",
            "numFirstSelections": 0
          },
          {
            "id": "7a0bd3e8-f2c7-4a33-ac39-ec3b0732c1d8",
            "text": "He selects developmentally appropriate materials and uses supportive instructional strategies to present the content sensitively.",
            "numFirstSelections": 0
          }
        ],
        "shuffle": false,
        "instruction": "Choose the best answer from the following options."
      },
      "tags": [
        {
          "id": 38014,
          "label": "Pre Test MCQs",
          "title": "Pre Test MCQs",
          "type": "Practice Test",
          "code": null,
          "displayType": [
            "Display",
            "Filter",
            "Progress"
          ]
        }
      ],
      "score": null
    },
    {
      "id": 104847,
      "versionId": 1,
      "blockId": null,
      "type": "MCQ",
      "parentId": null,
      "recordType": "ITEM",
      "content": {
        "stem": {
          "text": "Ms. Garcia is a new fifth-grade teacher. Her school uses an AI-driven learning platform that analyzes math test data and recommends whether each student should be placed in an advanced or regular math group. The learning platform data suggest that one of her students, Liam, should stay in a regular group due to a low pre-test score. However, Ms. Garcia knows Liam had a difficult day during testing, and he has shown strong math reasoning in class discussions. The department head advises following the platform’s data for consistency.\n\nWhich of the following actions is most appropriate for Ms. Garcia when making an ethical placement decision for Liam?"
        }
      },
      "metadata": {
        "type": "MCQ",
        "ui_type": "pre-test post-test question",
        "language": "en-US",
        "position": 3,
        "sourceId": 9003
      },
      "scoring": {
        "type": "EXACT_MATCH",
        "points": 1,
        "answerKey": [
          {
            "points": 0,
            "choiceId": "d221d38d-dbed-4b4d-af9e-520bb4595367",
            "isCorrect": false
          },
          {
            "points": 1,
            "choiceId": "79d67b31-55fe-478e-9434-dcab907a9dd8",
            "isCorrect": true
          },
          {
            "points": 0,
            "choiceId": "cf90226f-e666-40e0-9ec4-da2a3e8a69fe",
            "isCorrect": false
          }
        ],
        "selection": {
          "max": 1,
          "min": 1
        }
      },
      "feedback": [
        {
          "type": "STATIC",
          "choiceId": "79d67b31-55fe-478e-9434-dcab907a9dd8",
          "detailed": {
            "text": "Ms. Garcia is actively involved in deciding Liam’s placement instead of letting the AI-driven learning platform decide alone. By getting more information and collaborating with your team, you make a fairer decision and ensure students are placed correctly from the start, which is both responsible and student-centered. It shows that you value both the data and your own knowledge of the student."
          },
          "language": "en-US"
        }
      ],
      "response": {
        "type": "SINGLE_CHOICE",
        "choices": [
          {
            "id": "d221d38d-dbed-4b4d-af9e-520bb4595367",
            "text": "Place Liam in the regular math group as the platform suggests, trusting the AI’s data and keeping placement decisions consistent for all students.",
            "numFirstSelections": 0
          },
          {
            "id": "79d67b31-55fe-478e-9434-dcab907a9dd8",
            "text": "Discuss Liam’s case with her team or principal and gather more evidence before determining his math placement, making sure to include her own observations alongside the AI data.",
            "numFirstSelections": 0
          },
          {
            "id": "cf90226f-e666-40e0-9ec4-da2a3e8a69fe",
            "text": "Defer to the automated recommendation this time, but monitor Liam’s progress closely for a few weeks and move him to the advanced group later if he performs well.",
            "numFirstSelections": 0
          }
        ],
        "shuffle": false,
        "instruction": "Choose the best answer from the following options."
      },
      "tags": [
        {
          "id": 38014,
          "label": "Pre Test MCQs",
          "title": "Pre Test MCQs",
          "type": "Practice Test",
          "code": null,
          "displayType": [
            "Display",
            "Filter",
            "Progress"
          ]
        }
      ],
      "score": null
    },
    {
      "id": 104848,
      "versionId": 1,
      "blockId": null,
      "type": "MCQ",
      "parentId": null,
      "recordType": "ITEM",
      "content": {
        "stem": {
          "text": "Ms. Allen’s cat has just had kittens. She offers her students a discounted price on kittens from the litter.\n\nWhich of the following would have been most important for Ms. Allen, as a professional educator, to consider before making this offer?"
        }
      },
      "metadata": {
        "type": "MCQ",
        "ui_type": "pre-test post-test question",
        "language": "en-US",
        "position": 4,
        "sourceId": 9004
      },
      "scoring": {
        "type": "EXACT_MATCH",
        "points": 1,
        "answerKey": [
          {
            "points": 1,
            "choiceId": "8dc2d89a-f022-4eaa-8a1c-dde9b1a1c724",
            "isCorrect": true
          },
          {
            "points": 0,
            "choiceId": "1647ee4e-a390-48f6-8c36-ff061a3189b2",
            "isCorrect": false
          },
          {
            "points": 0,
            "choiceId": "e424d22c-8223-44c6-b399-b7f36a6f2b03",
            "isCorrect": false
          }
        ],
        "selection": {
          "max": 1,
          "min": 1
        }
      },
      "feedback": [
        {
          "type": "STATIC",
          "choiceId": "8dc2d89a-f022-4eaa-8a1c-dde9b1a1c724",
          "detailed": {
            "text": "Selling kittens to students creates the risk of a perceived conflict of interest. For example, if Ms. Allen makes a positive comment in the future about a student who purchased one of the kittens, other students may wonder whether the comment was in part due to Ms. Allen showing favoritism toward a customer. Of the options, this is the most central and applicable risk."
          },
          "language": "en-US"
        }
      ],
      "response": {
        "type": "SINGLE_CHOICE",
        "choices": [
          {
            "id": "8dc2d89a-f022-4eaa-8a1c-dde9b1a1c724",
            "text": "Selling kittens to students may create the potential for a conflict of interest.",
            "numFirstSelections": 0
          },
          {
            "id": "1647ee4e-a390-48f6-8c36-ff061a3189b2",
            "text": "Some students may be allergic to kittens and will feel left out.",
            "numFirstSelections": 0
          },
          {
            "id": "e424d22c-8223-44c6-b399-b7f36a6f2b03",
            "text": "There are not enough kittens for every student to buy one.",
            "numFirstSelections": 0
          }
        ],
        "shuffle": false,
        "instruction": "Choose the best answer from the following options."
      },
      "tags": [
        {
          "id": 38014,
          "label": "Pre Test MCQs",
          "title": "Pre Test MCQs",
          "type": "Practice Test",
          "code": null,
          "displayType": [
            "Display",
            "Filter",
            "Progress"
          ]
        }
      ],
      "score": null
    },
    {
      "id": 104849,
      "versionId": 1,
      "blockId": null,
      "type": "MCQ",
      "parentId": null,
      "recordType": "ITEM",
      "content": {
        "stem": {
          "text": "Ms. Wells, a yearbook advisor, needs to meet with the student editor-in-chief to discuss upcoming deadlines.\n\nWhich of the following settings best reflects appropriate professional boundaries for an ethical educator?"
        }
      },
      "metadata": {
        "type": "MCQ",
        "ui_type": "pre-test post-test question",
        "language": "en-US",
        "position": 5,
        "sourceId": 9005
      },
      "scoring": {
        "type": "EXACT_MATCH",
        "points": 1,
        "answerKey": [
          {
            "points": 0,
            "choiceId": "d84bd2b0-2367-46db-9d9d-6c2198702976",
            "isCorrect": false
          },
          {
            "points": 1,
            "choiceId": "1f132aa7-32ab-4637-b43a-9791b193c61a",
            "isCorrect": true
          },
          {
            "points": 0,
            "choiceId": "06c2c93d-64c9-4c41-b644-a7d1ae400639",
            "isCorrect": false
          }
        ],
        "selection": {
          "max": 1,
          "min": 1
        }
      },
      "feedback": [
        {
          "type": "STATIC",
          "choiceId": "1f132aa7-32ab-4637-b43a-9791b193c61a",
          "detailed": {
            "text": "Meeting during lunch in Ms. Wells’s classroom with the door open ensures that their discussion and conduct are transparent and professional. However, in the other options, their physical privacy and lack of transparency provide ample room for speculation about whether inappropriate conduct could have occurred."
          },
          "language": "en-US"
        }
      ],
      "response": {
        "type": "SINGLE_CHOICE",
        "choices": [
          {
            "id": "d84bd2b0-2367-46db-9d9d-6c2198702976",
            "text": "After school, in an office, with the door closed",
            "numFirstSelections": 0
          },
          {
            "id": "1f132aa7-32ab-4637-b43a-9791b193c61a",
            "text": "During lunch, in Ms. Wells’s classroom, with the door open",
            "numFirstSelections": 0
          },
          {
            "id": "06c2c93d-64c9-4c41-b644-a7d1ae400639",
            "text": "After school, at a café nearby that Ms. Wells and the student could walk to",
            "numFirstSelections": 0
          }
        ],
        "shuffle": false,
        "instruction": "Choose the best answer from the following options."
      },
      "tags": [
        {
          "id": 38014,
          "label": "Pre Test MCQs",
          "title": "Pre Test MCQs",
          "type": "Practice Test",
          "code": null,
          "displayType": [
            "Display",
            "Filter",
            "Progress"
          ]
        }
      ],
      "score": null
    },
    {
      "id": 104850,
      "versionId": 1,
      "blockId": null,
      "type": "MCQ",
      "parentId": null,
      "recordType": "ITEM",
      "content": {
        "stem": {
          "text": "A teacher learns that a school policy requires all suspected academic dishonesty to be reported and documented. While grading assignments, the teacher identifies clear evidence that a student has plagiarized work. The student asks the teacher not to report the incident and promises not to repeat the behavior.\n\nWhich of the following actions is most appropriate for the teacher to take?"
        }
      },
      "metadata": {
        "type": "MCQ",
        "ui_type": "pre-test post-test question",
        "language": "en-US",
        "position": 6,
        "sourceId": 9006
      },
      "scoring": {
        "type": "EXACT_MATCH",
        "points": 1,
        "answerKey": [
          {
            "points": 0,
            "choiceId": "ab6b8979-7b41-45f4-8379-875ee7b53756",
            "isCorrect": false
          },
          {
            "points": 1,
            "choiceId": "6d8b1c92-66be-476f-a8c7-6d077de426a2",
            "isCorrect": true
          },
          {
            "points": 0,
            "choiceId": "bcea8305-d208-4fb6-863e-43b3e78c7660",
            "isCorrect": false
          }
        ],
        "selection": {
          "max": 1,
          "min": 1
        }
      },
      "feedback": [
        {
          "type": "STATIC",
          "choiceId": "6d8b1c92-66be-476f-a8c7-6d077de426a2",
          "detailed": {
            "text": "Schools establish policies regarding academic integrity to ensure consistency, fairness, and accountability. By following these procedures, the teacher upholds institutional expectations, supports equitable treatment of all students, and helps maintain the integrity of the academic environment. Adhering to policy also ensures proper documentation and allows the school to respond in a systematic and transparent manner."
          },
          "language": "en-US"
        }
      ],
      "response": {
        "type": "SINGLE_CHOICE",
        "choices": [
          {
            "id": "ab6b8979-7b41-45f4-8379-875ee7b53756",
            "text": "Address the issue privately with the student, but do not report the incident.",
            "numFirstSelections": 0
          },
          {
            "id": "6d8b1c92-66be-476f-a8c7-6d077de426a2",
            "text": "Follow the school’s policy by reporting and documenting the incident.",
            "numFirstSelections": 0
          },
          {
            "id": "bcea8305-d208-4fb6-863e-43b3e78c7660",
            "text": "Allow the student to redo the assignment without further consequences.",
            "numFirstSelections": 0
          }
        ],
        "shuffle": false,
        "instruction": "Choose the best answer from the following options."
      },
      "tags": [
        {
          "id": 38014,
          "label": "Pre Test MCQs",
          "title": "Pre Test MCQs",
          "type": "Practice Test",
          "code": null,
          "displayType": [
            "Display",
            "Filter",
            "Progress"
          ]
        }
      ],
      "score": null
    },
    {
      "id": 104851,
      "versionId": 1,
      "blockId": null,
      "type": "MCQ",
      "parentId": null,
      "recordType": "ITEM",
      "content": {
        "stem": {
          "text": "Mr. Gervais, a social studies teacher, enters his fourth-period classroom and notices a distinctly chemical smell. Students in his class also notice the smell. Mr. Gervais calls the main office to report the smell and determine what action to take next.\n\nBy immediately reporting the unusual smell, Mr. Gervais is acting consistently with which of the following principles of the professional educator?"
        }
      },
      "metadata": {
        "type": "MCQ",
        "ui_type": "pre-test post-test question",
        "language": "en-US",
        "position": 7,
        "sourceId": 9007
      },
      "scoring": {
        "type": "EXACT_MATCH",
        "points": 1,
        "answerKey": [
          {
            "points": 1,
            "choiceId": "876cdcd2-d8b0-47a1-977b-3c631c465b9a",
            "isCorrect": true
          },
          {
            "points": 0,
            "choiceId": "6bfbeb6a-ee84-4e78-8fac-4548e63bce2c",
            "isCorrect": false
          },
          {
            "points": 0,
            "choiceId": "36597411-bd6c-4fea-ae4a-cdcb7b98e5ae",
            "isCorrect": false
          }
        ],
        "selection": {
          "max": 1,
          "min": 1
        }
      },
      "feedback": [
        {
          "type": "STATIC",
          "choiceId": "876cdcd2-d8b0-47a1-977b-3c631c465b9a",
          "detailed": {
            "text": "A chemical smell could indicate a gas leak or other hazard that could put students in physical danger. Mr. Gervais is right to look into the situation without delay. There is no indication that considerations of either transparency or objectivity are relevant to this situation."
          },
          "language": "en-US"
        }
      ],
      "response": {
        "type": "SINGLE_CHOICE",
        "choices": [
          {
            "id": "876cdcd2-d8b0-47a1-977b-3c631c465b9a",
            "text": "Ensuring student safety",
            "numFirstSelections": 0
          },
          {
            "id": "6bfbeb6a-ee84-4e78-8fac-4548e63bce2c",
            "text": "Maintaining objectivity",
            "numFirstSelections": 0
          },
          {
            "id": "36597411-bd6c-4fea-ae4a-cdcb7b98e5ae",
            "text": "Acting with transparency",
            "numFirstSelections": 0
          }
        ],
        "shuffle": false,
        "instruction": "Choose the best answer from the following options."
      },
      "tags": [
        {
          "id": 38014,
          "label": "Pre Test MCQs",
          "title": "Pre Test MCQs",
          "type": "Practice Test",
          "code": null,
          "displayType": [
            "Display",
            "Filter",
            "Progress"
          ]
        }
      ],
      "score": null
    },
    {
      "id": 104852,
      "versionId": 1,
      "blockId": null,
      "type": "MCQ",
      "parentId": null,
      "recordType": "ITEM",
      "content": {
        "stem": {
          "text": "Ms. Chen, an elementary teacher, discovers a free AI app called Cozy Reading that promises to improve student reading skills by analyzing each child’s reading progress. Ms. Chen is eager to use the app because it might help her students, and she thinks it only collects reading performance data.\n\nWhich of the following describes the most ethical way for Ms. Chen to handle this situation?"
        }
      },
      "metadata": {
        "type": "MCQ",
        "ui_type": "pre-test post-test question",
        "language": "en-US",
        "position": 8,
        "sourceId": 9008
      },
      "scoring": {
        "type": "EXACT_MATCH",
        "points": 1,
        "answerKey": [
          {
            "points": 0,
            "choiceId": "b9418916-a6c1-46ba-935c-d0af658e8886",
            "isCorrect": false
          },
          {
            "points": 1,
            "choiceId": "ff4924ce-1589-4dd1-acbc-1446b5bb7648",
            "isCorrect": true
          },
          {
            "points": 0,
            "choiceId": "4df822ac-c8d5-4fe3-81b3-31851e93534d",
            "isCorrect": false
          }
        ],
        "selection": {
          "max": 1,
          "min": 1
        }
      },
      "feedback": [
        {
          "type": "STATIC",
          "choiceId": "ff4924ce-1589-4dd1-acbc-1446b5bb7648",
          "detailed": {
            "text": "Ms. Chen demonstrates professional responsibility and ethical conduct by consulting her school’s technology staff to make sure that she does not violate district rules or federal privacy laws. She acknowledges that an ethical educator must balance innovation with caution and official processes."
          },
          "language": "en-US"
        }
      ],
      "response": {
        "type": "SINGLE_CHOICE",
        "choices": [
          {
            "id": "b9418916-a6c1-46ba-935c-d0af658e8886",
            "text": "Explain Cozy Reading’s benefits to parents or guardians and get their written permission for their children to use it, then implement the app if most parents agree.",
            "numFirstSelections": 0
          },
          {
            "id": "ff4924ce-1589-4dd1-acbc-1446b5bb7648",
            "text": "Consult her school’s technology coordinator to see if Cozy Reading is already approved or needs to be vetted, and hold off on using it until she gets official guidance.",
            "numFirstSelections": 0
          },
          {
            "id": "4df822ac-c8d5-4fe3-81b3-31851e93534d",
            "text": "Test Cozy Reading with a few students to see if it’s effective and safe before deciding whether to use it with the whole class.",
            "numFirstSelections": 0
          }
        ],
        "shuffle": false,
        "instruction": "Choose the best answer from the following options."
      },
      "tags": [
        {
          "id": 38014,
          "label": "Pre Test MCQs",
          "title": "Pre Test MCQs",
          "type": "Practice Test",
          "code": null,
          "displayType": [
            "Display",
            "Filter",
            "Progress"
          ]
        }
      ],
      "score": null
    },
    {
      "id": 104853,
      "versionId": 1,
      "blockId": null,
      "type": "MCQ",
      "parentId": null,
      "recordType": "ITEM",
      "content": {
        "stem": {
          "text": "Ms. Padron, an experienced third-grade teacher, has moved across the country and is applying for a job teaching elementary school in a new district. The job application form asks applicants to provide information about all degrees obtained or pursued and all teaching positions held, including the circumstances for termination from such positions, if any.\n\nMs. Padron will violate best practices for professional educators if she leaves out which of the following pieces of information about herself?"
        }
      },
      "metadata": {
        "type": "MCQ",
        "ui_type": "pre-test post-test question",
        "language": "en-US",
        "position": 9,
        "sourceId": 9009
      },
      "scoring": {
        "type": "EXACT_MATCH",
        "points": 1,
        "answerKey": [
          {
            "points": 0,
            "choiceId": "942d7d8e-4810-48a8-aa81-db782cf293e3",
            "isCorrect": false
          },
          {
            "points": 0,
            "choiceId": "f06fd6b9-616c-4263-98eb-b9daab2c28f5",
            "isCorrect": false
          },
          {
            "points": 1,
            "choiceId": "8492da92-9e17-4d94-8554-e6c894712944",
            "isCorrect": true
          }
        ],
        "selection": {
          "max": 1,
          "min": 1
        }
      },
      "feedback": [
        {
          "type": "STATIC",
          "choiceId": "8492da92-9e17-4d94-8554-e6c894712944",
          "detailed": {
            "text": "While the information may not seem consequential, Ms. Padron is obligated to respond fully and honestly to any legitimate inquiries about her professional qualifications and employment history. Her lifeguard job has nothing to do with her role as a teacher, so it is less important to report. Her plan to pursue a Ph.D. is admirable, but since she has not yet begun to pursue that degree formally, and it is possible that the plan will not actually materialize, she is not obligated to report it."
          },
          "language": "en-US"
        }
      ],
      "response": {
        "type": "SINGLE_CHOICE",
        "choices": [
          {
            "id": "942d7d8e-4810-48a8-aa81-db782cf293e3",
            "text": "She plans to pursue a Ph.D. in education.",
            "numFirstSelections": 0
          },
          {
            "id": "f06fd6b9-616c-4263-98eb-b9daab2c28f5",
            "text": "She worked as a lifeguard for several summers while teaching.",
            "numFirstSelections": 0
          },
          {
            "id": "8492da92-9e17-4d94-8554-e6c894712944",
            "text": "She was laid off after a year of teaching because of unexpected budget cuts.",
            "numFirstSelections": 0
          }
        ],
        "shuffle": false,
        "instruction": "Choose the best answer from the following options."
      },
      "tags": [
        {
          "id": 38014,
          "label": "Pre Test MCQs",
          "title": "Pre Test MCQs",
          "type": "Practice Test",
          "code": null,
          "displayType": [
            "Display",
            "Filter",
            "Progress"
          ]
        }
      ],
      "score": null
    },
    {
      "id": 104854,
      "versionId": 1,
      "blockId": null,
      "type": "MCQ",
      "parentId": null,
      "recordType": "ITEM",
      "content": {
        "stem": {
          "text": "A middle school principal learns that a teacher has been allowing a high-performing student to skip required classwork because the student is experiencing significant stress at home. The teacher explains that this flexibility is intended to support the student’s well-being.\n\nWhich of the following is the most appropriate action for the principal to take?"
        }
      },
      "metadata": {
        "type": "MCQ",
        "ui_type": "pre-test post-test question",
        "language": "en-US",
        "position": 10,
        "sourceId": 9010
      },
      "scoring": {
        "type": "EXACT_MATCH",
        "points": 1,
        "answerKey": [
          {
            "points": 0,
            "choiceId": "18c5b523-5b7f-4372-83c5-0452e58cecf9",
            "isCorrect": false
          },
          {
            "points": 1,
            "choiceId": "ae2354fe-24b9-446f-8857-17155011bb90",
            "isCorrect": true
          },
          {
            "points": 0,
            "choiceId": "cefe40eb-9002-4690-8a5e-168882bdb0dd",
            "isCorrect": false
          }
        ],
        "selection": {
          "max": 1,
          "min": 1
        }
      },
      "feedback": [
        {
          "type": "STATIC",
          "choiceId": "ae2354fe-24b9-446f-8857-17155011bb90",
          "detailed": {
            "text": "Meeting with the teacher to ensure that the student receives appropriate support while maintaining fair and consistent academic expectations is the most appropriate action because it reflects ethical leadership that prioritizes both student well-being and equity."
          },
          "language": "en-US"
        }
      ],
      "response": {
        "type": "SINGLE_CHOICE",
        "choices": [
          {
            "id": "18c5b523-5b7f-4372-83c5-0452e58cecf9",
            "text": "Supporting the teacher’s decision to adjust expectations to reduce stress for the student",
            "numFirstSelections": 0
          },
          {
            "id": "ae2354fe-24b9-446f-8857-17155011bb90",
            "text": "Meeting with the teacher to ensure that the student receives appropriate support while maintaining fair and consistent academic expectations",
            "numFirstSelections": 0
          },
          {
            "id": "cefe40eb-9002-4690-8a5e-168882bdb0dd",
            "text": "Informing the student that personal challenges should not affect academic responsibilities, and requiring all missed work to be completed immediately",
            "numFirstSelections": 0
          }
        ],
        "shuffle": false,
        "instruction": "Choose the best answer from the following options."
      },
      "tags": [
        {
          "id": 38014,
          "label": "Pre Test MCQs",
          "title": "Pre Test MCQs",
          "type": "Practice Test",
          "code": null,
          "displayType": [
            "Display",
            "Filter",
            "Progress"
          ]
        }
      ],
      "score": null
    },
    {
      "id": 104855,
      "versionId": 1,
      "blockId": null,
      "type": "MCQ",
      "parentId": null,
      "recordType": "ITEM",
      "content": {
        "stem": {
          "text": "Ms. Graff, a sixth-grade math teacher, notices that her co-teacher, Ms. Dove, calls on boys more frequently than girls during class. She considers whether this pattern may reflect unconscious bias.\n\nWhich of the following responses by Ms. Graff is most consistent with best practices for professional educators?"
        }
      },
      "metadata": {
        "type": "MCQ",
        "ui_type": "pre-test post-test question",
        "language": "en-US",
        "position": 11,
        "sourceId": 9011
      },
      "scoring": {
        "type": "EXACT_MATCH",
        "points": 1,
        "answerKey": [
          {
            "points": 1,
            "choiceId": "b32764df-6c12-40e5-b0ae-946b7ca1532a",
            "isCorrect": true
          },
          {
            "points": 0,
            "choiceId": "75fbffed-3518-4389-8afe-7f093e7b91d2",
            "isCorrect": false
          },
          {
            "points": 0,
            "choiceId": "724bb114-b16b-4cc3-9c37-90a782c5337c",
            "isCorrect": false
          }
        ],
        "selection": {
          "max": 1,
          "min": 1
        }
      },
      "feedback": [
        {
          "type": "STATIC",
          "choiceId": "b32764df-6c12-40e5-b0ae-946b7ca1532a",
          "detailed": {
            "text": "Bias, conscious or unconscious, is a serious matter. If bias does exist in the classroom, the quality of education for the girls is likely being compromised. To be proactive, Ms. Graff should raise the issue with Ms. Dove or possibly with her supervisor, even though doing so may make her feel uncomfortable."
          },
          "language": "en-US"
        }
      ],
      "response": {
        "type": "SINGLE_CHOICE",
        "choices": [
          {
            "id": "b32764df-6c12-40e5-b0ae-946b7ca1532a",
            "text": "Raising the possibility of unconscious gender bias with Ms. Dove or her supervisor in a supportive manner",
            "numFirstSelections": 0
          },
          {
            "id": "75fbffed-3518-4389-8afe-7f093e7b91d2",
            "text": "Waiting for a period of time and observing before raising the issue with Ms. Dove or others",
            "numFirstSelections": 0
          },
          {
            "id": "724bb114-b16b-4cc3-9c37-90a782c5337c",
            "text": "Consulting other math teachers at the school to see if they have noticed such a pattern before deciding what to do",
            "numFirstSelections": 0
          }
        ],
        "shuffle": false,
        "instruction": "Choose the best answer from the following options."
      },
      "tags": [
        {
          "id": 38014,
          "label": "Pre Test MCQs",
          "title": "Pre Test MCQs",
          "type": "Practice Test",
          "code": null,
          "displayType": [
            "Display",
            "Filter",
            "Progress"
          ]
        }
      ],
      "score": null
    },
    {
      "id": 104856,
      "versionId": 1,
      "blockId": null,
      "type": "MCQ",
      "parentId": null,
      "recordType": "ITEM",
      "content": {
        "stem": {
          "text": "While returning from a field trip, a student tells Ms. Hayden she feels depressed after a recent family death. Ms. Hayden discreetly offers the student advice on coping with the loss.\n\nWhich of the following principles does Ms. Hayden most clearly put at risk in responding this way?"
        }
      },
      "metadata": {
        "type": "MCQ",
        "ui_type": "pre-test post-test question",
        "language": "en-US",
        "position": 12,
        "sourceId": 9012
      },
      "scoring": {
        "type": "EXACT_MATCH",
        "points": 1,
        "answerKey": [
          {
            "points": 0,
            "choiceId": "e90cc04b-a7dc-4ff2-b4fa-be5fa7a33544",
            "isCorrect": false
          },
          {
            "points": 0,
            "choiceId": "141f204f-7cfb-4c75-baba-b899a6fb0341",
            "isCorrect": false
          },
          {
            "points": 1,
            "choiceId": "699ca2df-3446-4f5a-b820-82c5021a73c1",
            "isCorrect": true
          }
        ],
        "selection": {
          "max": 1,
          "min": 1
        }
      },
      "feedback": [
        {
          "type": "STATIC",
          "choiceId": "699ca2df-3446-4f5a-b820-82c5021a73c1",
          "detailed": {
            "text": "Providing advice on coping with depression moves beyond the teacher’s role and into the domain of mental health counseling. While Ms. Hayden is responding with care and concern, offering guidance on managing emotional distress related to bereavement may exceed the boundaries of her professional training and certification."
          },
          "language": "en-US"
        }
      ],
      "response": {
        "type": "SINGLE_CHOICE",
        "choices": [
          {
            "id": "e90cc04b-a7dc-4ff2-b4fa-be5fa7a33544",
            "text": "Acting in ways that avoid possible reputational damage",
            "numFirstSelections": 0
          },
          {
            "id": "141f204f-7cfb-4c75-baba-b899a6fb0341",
            "text": "Maintaining confidentiality in interactions with students",
            "numFirstSelections": 0
          },
          {
            "id": "699ca2df-3446-4f5a-b820-82c5021a73c1",
            "text": "Performing duties within the limits of one’s certification, licensure, and training",
            "numFirstSelections": 0
          }
        ],
        "shuffle": false,
        "instruction": "Choose the best answer from the following options."
      },
      "tags": [
        {
          "id": 38014,
          "label": "Pre Test MCQs",
          "title": "Pre Test MCQs",
          "type": "Practice Test",
          "code": null,
          "displayType": [
            "Display",
            "Filter",
            "Progress"
          ]
        }
      ],
      "score": null
    },
    {
      "id": 104857,
      "versionId": 1,
      "blockId": null,
      "type": "MCQ",
      "parentId": null,
      "recordType": "ITEM",
      "content": {
        "stem": {
          "text": "A physical education teacher is under investigation after a report that they made an inappropriate comment to a student during gym. An investigator with the state’s Professional Practices Commission asks a colleague of the physical education teacher if they know anything relevant to the investigation. The colleague tells the investigator that they have heard the physical education teacher shouting angrily at the students on several occasions.\n\nWhich of the following is most important for the colleague to consider when responding to the investigator?"
        }
      },
      "metadata": {
        "type": "MCQ",
        "ui_type": "pre-test post-test question",
        "language": "en-US",
        "position": 13,
        "sourceId": 9013
      },
      "scoring": {
        "type": "EXACT_MATCH",
        "points": 1,
        "answerKey": [
          {
            "points": 1,
            "choiceId": "da6e2166-e58c-4fb1-8dbe-eca54274b16d",
            "isCorrect": true
          },
          {
            "points": 0,
            "choiceId": "ce686ea1-6270-447f-9baf-4f9d67dd3b36",
            "isCorrect": false
          },
          {
            "points": 0,
            "choiceId": "e83acc85-71a8-4aa2-bd03-1a913b776645",
            "isCorrect": false
          }
        ],
        "selection": {
          "max": 1,
          "min": 1
        }
      },
      "feedback": [
        {
          "type": "STATIC",
          "choiceId": "da6e2166-e58c-4fb1-8dbe-eca54274b16d",
          "detailed": {
            "text": "Since the colleague is aware of actions by the physical education teacher that have a direct bearing on the matter under investigation, they are obligated to report those actions. Concern for the teacher’s reputation, or for the relationships among teachers at the school, should not prevent the colleague from participating fully in an ethics investigation."
          },
          "language": "en-US"
        }
      ],
      "response": {
        "type": "SINGLE_CHOICE",
        "choices": [
          {
            "id": "da6e2166-e58c-4fb1-8dbe-eca54274b16d",
            "text": "Their obligation to cooperate fully with ethics investigations",
            "numFirstSelections": 0
          },
          {
            "id": "ce686ea1-6270-447f-9baf-4f9d67dd3b36",
            "text": "The danger of damaging the physical education teacher's reputation",
            "numFirstSelections": 0
          },
          {
            "id": "e83acc85-71a8-4aa2-bd03-1a913b776645",
            "text": "The way their response may affect relationships among teachers",
            "numFirstSelections": 0
          }
        ],
        "shuffle": false,
        "instruction": "Choose the best answer from the following options."
      },
      "tags": [
        {
          "id": 38014,
          "label": "Pre Test MCQs",
          "title": "Pre Test MCQs",
          "type": "Practice Test",
          "code": null,
          "displayType": [
            "Display",
            "Filter",
            "Progress"
          ]
        }
      ],
      "score": null
    },
    {
      "id": 104858,
      "versionId": 1,
      "blockId": null,
      "type": "MCQ",
      "parentId": null,
      "recordType": "ITEM",
      "content": {
        "stem": {
          "text": "Mr. Gray, a second-grade teacher, uses an AI platform that automatically sorts his students into skill-based groups after a mathematics diagnostic test. The AI recommends placing all four English learners (ELs) into one group. Mr. Gray reviews his notes and sees that two of the ELs are at grade level, and two are below grade level. The platform provides no explanation for its grouping decisions.\n\nWhich of the following is the most ethical way for Mr. Gray to handle the situation?"
        }
      },
      "metadata": {
        "type": "MCQ",
        "ui_type": "pre-test post-test question",
        "language": "en-US",
        "position": 14,
        "sourceId": 9014
      },
      "scoring": {
        "type": "EXACT_MATCH",
        "points": 1,
        "answerKey": [
          {
            "points": 1,
            "choiceId": "02e91ef9-7b46-40f2-af55-61486103b8ad",
            "isCorrect": true
          },
          {
            "points": 0,
            "choiceId": "5574ce0a-bef9-4744-9432-94f7e4b68cf5",
            "isCorrect": false
          },
          {
            "points": 0,
            "choiceId": "0ff08d04-238f-4747-b910-a516e53ec312",
            "isCorrect": false
          }
        ],
        "selection": {
          "max": 1,
          "min": 1
        }
      },
      "feedback": [
        {
          "type": "STATIC",
          "choiceId": "02e91ef9-7b46-40f2-af55-61486103b8ad",
          "detailed": {
            "text": "Mr. Gray stays actively involved instead of just doing what the AI says. By double-checking the test data and consulting experts, he ensures the groupings are fair and right for each student. This way, if the AI’s recommendation is off due to a bias or a one-time test issue, he will catch it and protect his students."
          },
          "language": "en-US"
        }
      ],
      "response": {
        "type": "SINGLE_CHOICE",
        "choices": [
          {
            "id": "02e91ef9-7b46-40f2-af55-61486103b8ad",
            "text": "Review the diagnostic data and consult a mathematics specialist to determine if the AI’s grouping is appropriate, since the errors may have affected the results.",
            "numFirstSelections": 0
          },
          {
            "id": "5574ce0a-bef9-4744-9432-94f7e4b68cf5",
            "text": "Disregard the AI’s grouping and use his own judgment to place the ELs in different groups, since the students need curricular material at their level.",
            "numFirstSelections": 0
          },
          {
            "id": "0ff08d04-238f-4747-b910-a516e53ec312",
            "text": "Trust the AI’s grouping fully and place the ELs in one group as recommended, since data-driven consistency is important.",
            "numFirstSelections": 0
          }
        ],
        "shuffle": false,
        "instruction": "Choose the best answer from the following options."
      },
      "tags": [
        {
          "id": 38014,
          "label": "Pre Test MCQs",
          "title": "Pre Test MCQs",
          "type": "Practice Test",
          "code": null,
          "displayType": [
            "Display",
            "Filter",
            "Progress"
          ]
        }
      ],
      "score": null
    },
    {
      "id": 104859,
      "versionId": 1,
      "blockId": null,
      "type": "MCQ",
      "parentId": null,
      "recordType": "ITEM",
      "content": {
        "stem": {
          "text": "The student council adviser, who is in charge of teacher chaperones at a school dance, notices that one of the chaperones appears to be impaired and not able to carry out their responsibilities effectively.\n\nWhich of the following should the student council adviser do?"
        }
      },
      "metadata": {
        "type": "MCQ",
        "ui_type": "pre-test post-test question",
        "language": "en-US",
        "position": 15,
        "sourceId": 9015
      },
      "scoring": {
        "type": "EXACT_MATCH",
        "points": 1,
        "answerKey": [
          {
            "points": 0,
            "choiceId": "52fa5aa6-45ad-4542-9e25-907823fafbfa",
            "isCorrect": false
          },
          {
            "points": 1,
            "choiceId": "45c96b17-d7d8-4ebd-915a-66c205bed0fd",
            "isCorrect": true
          },
          {
            "points": 0,
            "choiceId": "c842315c-9188-4ae2-a619-e64131d79d65",
            "isCorrect": false
          }
        ],
        "selection": {
          "max": 1,
          "min": 1
        }
      },
      "feedback": [
        {
          "type": "STATIC",
          "choiceId": "45c96b17-d7d8-4ebd-915a-66c205bed0fd",
          "detailed": {
            "text": "Asking the chaperone to leave the event and promptly notifying a school administrator is the most appropriate action because it prioritizes student safety, professional responsibility, and accountability."
          },
          "language": "en-US"
        }
      ],
      "response": {
        "type": "SINGLE_CHOICE",
        "choices": [
          {
            "id": "52fa5aa6-45ad-4542-9e25-907823fafbfa",
            "text": "Assign the chaperone to a location where they will have limited interaction with students.",
            "numFirstSelections": 0
          },
          {
            "id": "45c96b17-d7d8-4ebd-915a-66c205bed0fd",
            "text": "Ask the chaperone to leave the event and notify a school administrator of the situation as soon as possible.",
            "numFirstSelections": 0
          },
          {
            "id": "c842315c-9188-4ae2-a619-e64131d79d65",
            "text": "Inform other chaperones about the situation and ask them not to say anything about it.",
            "numFirstSelections": 0
          }
        ],
        "shuffle": false,
        "instruction": "Choose the best answer from the following options."
      },
      "tags": [
        {
          "id": 38014,
          "label": "Pre Test MCQs",
          "title": "Pre Test MCQs",
          "type": "Practice Test",
          "code": null,
          "displayType": [
            "Display",
            "Filter",
            "Progress"
          ]
        }
      ],
      "score": null
    },
    {
      "id": 104860,
      "versionId": 1,
      "blockId": null,
      "type": "MCQ",
      "parentId": null,
      "recordType": "ITEM",
      "content": {
        "stem": {
          "text": "Ms. Whittaker, a teacher, enters the teachers’ lounge and notices a strong odor that may indicate substance use.\n\nWhich of the following is the most appropriate action for Ms. Whittaker to take?"
        }
      },
      "metadata": {
        "type": "MCQ",
        "ui_type": "pre-test post-test question",
        "language": "en-US",
        "position": 16,
        "sourceId": 9016
      },
      "scoring": {
        "type": "EXACT_MATCH",
        "points": 1,
        "answerKey": [
          {
            "points": 1,
            "choiceId": "a5f29003-cd86-4490-b360-259996f85e82",
            "isCorrect": true
          },
          {
            "points": 0,
            "choiceId": "92b6607b-abd2-4a92-816a-dd8548dfa5d0",
            "isCorrect": false
          },
          {
            "points": 0,
            "choiceId": "530ebff1-6724-4dfb-b2f8-6691fd40b4fa",
            "isCorrect": false
          }
        ],
        "selection": {
          "max": 1,
          "min": 1
        }
      },
      "feedback": [
        {
          "type": "STATIC",
          "choiceId": "a5f29003-cd86-4490-b360-259996f85e82",
          "detailed": {
            "text": "Possession of illegal drugs on school property is a criminal act. A professional educator is obligated to report the situation to the principal or appropriate authority. Covering up the odor or gossiping fails to meet the ethical duty of stewardship of the law and public trust."
          },
          "language": "en-US"
        }
      ],
      "response": {
        "type": "SINGLE_CHOICE",
        "choices": [
          {
            "id": "a5f29003-cd86-4490-b360-259996f85e82",
            "text": "Immediately inform the principal of the situation.",
            "numFirstSelections": 0
          },
          {
            "id": "92b6607b-abd2-4a92-816a-dd8548dfa5d0",
            "text": "Use an odor-eliminating spray to protect her colleague’s reputation.",
            "numFirstSelections": 0
          },
          {
            "id": "530ebff1-6724-4dfb-b2f8-6691fd40b4fa",
            "text": "Privately tell another teacher what she noticed.",
            "numFirstSelections": 0
          }
        ],
        "shuffle": false,
        "instruction": "Choose the best answer from the following options."
      },
      "tags": [
        {
          "id": 38014,
          "label": "Pre Test MCQs",
          "title": "Pre Test MCQs",
          "type": "Practice Test",
          "code": null,
          "displayType": [
            "Display",
            "Filter",
            "Progress"
          ]
        }
      ],
      "score": null
    },
    {
      "id": 104861,
      "versionId": 1,
      "blockId": null,
      "type": "MCQ",
      "parentId": null,
      "recordType": "ITEM",
      "content": {
        "stem": {
          "text": "Mr. Tuan is collecting money from his students for their yearbooks.\n\nWhich of the following actions would best ensure that Mr. Tuan acts in alignment with the ethical principles for professional educators?"
        }
      },
      "metadata": {
        "type": "MCQ",
        "ui_type": "pre-test post-test question",
        "language": "en-US",
        "position": 17,
        "sourceId": 9017
      },
      "scoring": {
        "type": "EXACT_MATCH",
        "points": 1,
        "answerKey": [
          {
            "points": 0,
            "choiceId": "959a1847-e931-403a-9948-2b3ba7644e86",
            "isCorrect": false
          },
          {
            "points": 0,
            "choiceId": "5a6520c5-0278-4a49-813e-931403cc38f8",
            "isCorrect": false
          },
          {
            "points": 1,
            "choiceId": "3fcc2b95-ce31-4e27-86e8-f75cd8178c47",
            "isCorrect": true
          }
        ],
        "selection": {
          "max": 1,
          "min": 1
        }
      },
      "feedback": [
        {
          "type": "STATIC",
          "choiceId": "3fcc2b95-ce31-4e27-86e8-f75cd8178c47",
          "detailed": {
            "text": "A best practice for educators in this kind of situation is to treat public funds with a high level of honesty, accuracy, and responsibility. The other options do not demonstrate this behavior because they involve commingling personal funds or accounts with school-related funds."
          },
          "language": "en-US"
        }
      ],
      "response": {
        "type": "SINGLE_CHOICE",
        "choices": [
          {
            "id": "959a1847-e931-403a-9948-2b3ba7644e86",
            "text": "He should deposit the money he collects into his personal checking account and then write a check to the school for the total amount.",
            "numFirstSelections": 0
          },
          {
            "id": "5a6520c5-0278-4a49-813e-931403cc38f8",
            "text": "He should instruct the students to add money to his account with an online payment system so he can pay for the yearbooks directly.",
            "numFirstSelections": 0
          },
          {
            "id": "3fcc2b95-ce31-4e27-86e8-f75cd8178c47",
            "text": "He should keep track of the money he collects from each student and secure the money in the school office each day until the yearbook advisor collects it.",
            "numFirstSelections": 0
          }
        ],
        "shuffle": false,
        "instruction": "Choose the best answer from the following options."
      },
      "tags": [
        {
          "id": 38014,
          "label": "Pre Test MCQs",
          "title": "Pre Test MCQs",
          "type": "Practice Test",
          "code": null,
          "displayType": [
            "Display",
            "Filter",
            "Progress"
          ]
        }
      ],
      "score": null
    },
    {
      "id": 104862,
      "versionId": 1,
      "blockId": null,
      "type": "MCQ",
      "parentId": null,
      "recordType": "ITEM",
      "content": {
        "stem": {
          "text": "The principal of an elementary school promotes open communication between the school, parents, and the community. After back-to-school night, the principal receives phone calls from parents expressing concern that Ms. Conroy, their children’s classroom teacher, greeted them with a negative attitude and made them feel uncomfortable visiting the school.\n\nWhich of the following is the most appropriate initial action for the principal to take to address the parents’ concerns?"
        }
      },
      "metadata": {
        "type": "MCQ",
        "ui_type": "pre-test post-test question",
        "language": "en-US",
        "position": 18,
        "sourceId": 9018
      },
      "scoring": {
        "type": "EXACT_MATCH",
        "points": 1,
        "answerKey": [
          {
            "points": 0,
            "choiceId": "ee4d9103-c1fe-4d92-a75c-c13c2e5a848b",
            "isCorrect": false
          },
          {
            "points": 1,
            "choiceId": "3122ffdc-257b-446d-9f99-2dd2457e0609",
            "isCorrect": true
          },
          {
            "points": 0,
            "choiceId": "cfd68838-c92c-464a-b97d-cfc5e5985ac0",
            "isCorrect": false
          }
        ],
        "selection": {
          "max": 1,
          "min": 1
        }
      },
      "feedback": [
        {
          "type": "STATIC",
          "choiceId": "3122ffdc-257b-446d-9f99-2dd2457e0609",
          "detailed": {
            "text": "Meeting privately with Ms. Conroy to share the parents’ concerns and collaboratively develop strategies to improve her interactions with families is the most appropriate initial action because it reflects effective instructional leadership, professionalism, and responsiveness to stakeholder concerns."
          },
          "language": "en-US"
        }
      ],
      "response": {
        "type": "SINGLE_CHOICE",
        "choices": [
          {
            "id": "ee4d9103-c1fe-4d92-a75c-c13c2e5a848b",
            "text": "Responding to parents by assuring them that the issue will be addressed while encouraging them to communicate directly with Ms. Conroy",
            "numFirstSelections": 0
          },
          {
            "id": "3122ffdc-257b-446d-9f99-2dd2457e0609",
            "text": "Meeting privately with Ms. Conroy to share the parents’ concerns and collaboratively develop strategies to improve her interactions with families",
            "numFirstSelections": 0
          },
          {
            "id": "cfd68838-c92c-464a-b97d-cfc5e5985ac0",
            "text": "Addressing the importance of maintaining positive communication with families during a general staff meeting, without identifying specific individuals",
            "numFirstSelections": 0
          }
        ],
        "shuffle": false,
        "instruction": "Choose the best answer from the following options."
      },
      "tags": [
        {
          "id": 38014,
          "label": "Pre Test MCQs",
          "title": "Pre Test MCQs",
          "type": "Practice Test",
          "code": null,
          "displayType": [
            "Display",
            "Filter",
            "Progress"
          ]
        }
      ],
      "score": null
    },
    {
      "id": 104863,
      "versionId": 1,
      "blockId": null,
      "type": "MCQ",
      "parentId": null,
      "recordType": "ITEM",
      "content": {
        "stem": {
          "text": "Mr. Wolf wants to have easy access to his students’ academic records, so he downloads them and saves them to his personal Web-based cloud account.\n\nWhich of the following describes a main problem with this practice?"
        }
      },
      "metadata": {
        "type": "MCQ",
        "ui_type": "pre-test post-test question",
        "language": "en-US",
        "position": 19,
        "sourceId": 9019
      },
      "scoring": {
        "type": "EXACT_MATCH",
        "points": 1,
        "answerKey": [
          {
            "points": 0,
            "choiceId": "c37f9f17-2e72-4ddb-9c1b-ce5e81615924",
            "isCorrect": false
          },
          {
            "points": 0,
            "choiceId": "78bc9239-e19a-4093-a76a-a9494cdcfea1",
            "isCorrect": false
          },
          {
            "points": 1,
            "choiceId": "b022d600-f524-400b-9c44-8980fd3f2f8d",
            "isCorrect": true
          }
        ],
        "selection": {
          "max": 1,
          "min": 1
        }
      },
      "feedback": [
        {
          "type": "STATIC",
          "choiceId": "b022d600-f524-400b-9c44-8980fd3f2f8d",
          "detailed": {
            "text": "Student documents must be stored only in secure facilities, directories, or databases maintained by the school or district. Personal cloud accounts are not institutionally secured, making confidential student records vulnerable to unauthorized access."
          },
          "language": "en-US"
        }
      ],
      "response": {
        "type": "SINGLE_CHOICE",
        "choices": [
          {
            "id": "c37f9f17-2e72-4ddb-9c1b-ce5e81615924",
            "text": "Regularly referring to student academic records may bias the teacher's grading decisions.",
            "numFirstSelections": 0
          },
          {
            "id": "78bc9239-e19a-4093-a76a-a9494cdcfea1",
            "text": "The teacher is not entitled to have access to student academic records.",
            "numFirstSelections": 0
          },
          {
            "id": "b022d600-f524-400b-9c44-8980fd3f2f8d",
            "text": "A personal Web-based cloud account is not secure and puts the records at risk.",
            "numFirstSelections": 0
          }
        ],
        "shuffle": false,
        "instruction": "Choose the best answer from the following options."
      },
      "tags": [
        {
          "id": 38014,
          "label": "Pre Test MCQs",
          "title": "Pre Test MCQs",
          "type": "Practice Test",
          "code": null,
          "displayType": [
            "Display",
            "Filter",
            "Progress"
          ]
        }
      ],
      "score": null
    },
    {
      "id": 104864,
      "versionId": 1,
      "blockId": null,
      "type": "MCQ",
      "parentId": null,
      "recordType": "ITEM",
      "content": {
        "stem": {
          "text": "Mr. Acosta, a second-grade teacher, wants to post photos of student artwork on the school’s social media account to celebrate student achievement. He plans to use an AI tool that automatically generates captions and hashtags from the images. Several students’ faces are clearly visible in photos of their projects.\nWhich of the following is Mr. Acosta’s primary ethical obligation before posting?"
        }
      },
      "metadata": {
        "type": "MCQ",
        "ui_type": "pre-test post-test question",
        "language": "en-US",
        "position": 20,
        "sourceId": 9020
      },
      "scoring": {
        "type": "EXACT_MATCH",
        "points": 1,
        "answerKey": [
          {
            "points": 1,
            "choiceId": "55112eb3-c81f-45ea-8e1d-2a2d5b4d86bb",
            "isCorrect": true
          },
          {
            "points": 0,
            "choiceId": "8ca921b6-0b3d-4a46-9014-aa5b7b7708a3",
            "isCorrect": false
          },
          {
            "points": 0,
            "choiceId": "a2d8679f-505d-4a22-af52-bfe347d7d6f2",
            "isCorrect": false
          }
        ],
        "selection": {
          "max": 1,
          "min": 1
        }
      },
      "feedback": [
        {
          "type": "STATIC",
          "choiceId": "55112eb3-c81f-45ea-8e1d-2a2d5b4d86bb",
          "detailed": {
            "text": "Mr. Acosta must protect student privacy by obtaining informed consent before sharing images that include personally identifiable information. He also has a responsibility to ensure student images are not used to train AI systems without permission. This reflects the educator’s duty to maintain confidentiality and comply with laws and policies designed to protect students."
          },
          "language": "en-US"
        }
      ],
      "response": {
        "type": "SINGLE_CHOICE",
        "choices": [
          {
            "id": "55112eb3-c81f-45ea-8e1d-2a2d5b4d86bb",
            "text": "Ensuring that he has written media consent from parents or guardians and that the AI tool will not use student images to train AI systems without consent",
            "numFirstSelections": 0
          },
          {
            "id": "8ca921b6-0b3d-4a46-9014-aa5b7b7708a3",
            "text": "Making sure the posts align with the school’s social media branding guidelines",
            "numFirstSelections": 0
          },
          {
            "id": "a2d8679f-505d-4a22-af52-bfe347d7d6f2",
            "text": "Checking that the hashtags generated by AI will increase engagement with the posts",
            "numFirstSelections": 0
          }
        ],
        "shuffle": false,
        "instruction": "Choose the best answer from the following options."
      },
      "tags": [
        {
          "id": 38014,
          "label": "Pre Test MCQs",
          "title": "Pre Test MCQs",
          "type": "Practice Test",
          "code": null,
          "displayType": [
            "Display",
            "Filter",
            "Progress"
          ]
        }
      ],
      "score": null
    },
    {
      "id": 104865,
      "versionId": 1,
      "blockId": null,
      "type": "MCQ",
      "parentId": null,
      "recordType": "ITEM",
      "content": {
        "stem": {
          "text": "A group of high school students has created a website that includes comments about the physical appearance of several classmates.\n\nWhich of the following should be the teacher's primary concern?"
        }
      },
      "metadata": {
        "type": "MCQ",
        "ui_type": "pre-test post-test question",
        "language": "en-US",
        "position": 21,
        "sourceId": 9021
      },
      "scoring": {
        "type": "EXACT_MATCH",
        "points": 1,
        "answerKey": [
          {
            "points": 1,
            "choiceId": "9862462e-0e51-4ffb-bbfd-07c3ee004e77",
            "isCorrect": true
          },
          {
            "points": 0,
            "choiceId": "133a5aa0-9a24-4ea2-ac95-06cef91d03bf",
            "isCorrect": false
          },
          {
            "points": 0,
            "choiceId": "b2b181dd-e6e8-48be-bed3-840e1200a23e",
            "isCorrect": false
          }
        ],
        "selection": {
          "max": 1,
          "min": 1
        }
      },
      "feedback": [
        {
          "type": "STATIC",
          "choiceId": "9862462e-0e51-4ffb-bbfd-07c3ee004e77",
          "detailed": {
            "text": "The most immediate ethical concern is the potential for psychological harm to the students being targeted. Cyberbullying can cause serious emotional distress and undermine a safe learning environment. Educators have a responsibility to be vigilant in identifying and addressing such behavior."
          },
          "language": "en-US"
        }
      ],
      "response": {
        "type": "SINGLE_CHOICE",
        "choices": [
          {
            "id": "9862462e-0e51-4ffb-bbfd-07c3ee004e77",
            "text": "The possibility that the site is a form of cyberbullying that may cause psychological harm to students and adversely affect the learning environment",
            "numFirstSelections": 0
          },
          {
            "id": "133a5aa0-9a24-4ea2-ac95-06cef91d03bf",
            "text": "The risk that students are using technology for non-academic purposes during school hours",
            "numFirstSelections": 0
          },
          {
            "id": "b2b181dd-e6e8-48be-bed3-840e1200a23e",
            "text": "The potential for the website to attract attention from individuals outside the school community",
            "numFirstSelections": 0
          }
        ],
        "shuffle": false,
        "instruction": "Choose the best answer from the following options."
      },
      "tags": [
        {
          "id": 38014,
          "label": "Pre Test MCQs",
          "title": "Pre Test MCQs",
          "type": "Practice Test",
          "code": null,
          "displayType": [
            "Display",
            "Filter",
            "Progress"
          ]
        }
      ],
      "score": null
    },
    {
      "id": 104866,
      "versionId": 1,
      "blockId": null,
      "type": "MCQ",
      "parentId": null,
      "recordType": "ITEM",
      "content": {
        "stem": {
          "text": "Mr. Willis, a high school principal, discovers that one of his science teachers, Mr. Eckhart, has been downloading lesson plans from an online source and submitting them as his own original work.\n\nWhich of the following best describes the ethical concern with Mr. Eckhart’s actions?"
        }
      },
      "metadata": {
        "type": "MCQ",
        "ui_type": "pre-test post-test question",
        "language": "en-US",
        "position": 22,
        "sourceId": 9022
      },
      "scoring": {
        "type": "EXACT_MATCH",
        "points": 1,
        "answerKey": [
          {
            "points": 0,
            "choiceId": "f14e9f6b-d6be-46d6-ba3e-6775ca8e215e",
            "isCorrect": false
          },
          {
            "points": 0,
            "choiceId": "9a942d43-091d-4aea-82bd-9db38bb97279",
            "isCorrect": false
          },
          {
            "points": 1,
            "choiceId": "3392d0d5-c2ea-4663-9113-2a0f26c77db8",
            "isCorrect": true
          }
        ],
        "selection": {
          "max": 1,
          "min": 1
        }
      },
      "feedback": [
        {
          "type": "STATIC",
          "choiceId": "3392d0d5-c2ea-4663-9113-2a0f26c77db8",
          "detailed": {
            "text": "Professional educators are expected to properly attribute the work of others. Submitting lesson plans sourced online as one's own original work is a form of misrepresentation that violates the code of ethics. The principal should meet privately with the teacher to discuss ethical best practices, including the obligation to recognize and cite others' work."
          },
          "language": "en-US"
        }
      ],
      "response": {
        "type": "SINGLE_CHOICE",
        "choices": [
          {
            "id": "f14e9f6b-d6be-46d6-ba3e-6775ca8e215e",
            "text": "Educators should work to ensure that their students have equitable access to the curriculum.",
            "numFirstSelections": 0
          },
          {
            "id": "9a942d43-091d-4aea-82bd-9db38bb97279",
            "text": "Educators should regularly reflect on and update their professional skills, content knowledge, and competencies.",
            "numFirstSelections": 0
          },
          {
            "id": "3392d0d5-c2ea-4663-9113-2a0f26c77db8",
            "text": "Educators should cite materials from published or electronic sources when they disseminate information.",
            "numFirstSelections": 0
          }
        ],
        "shuffle": false,
        "instruction": "Choose the best answer from the following options."
      },
      "tags": [
        {
          "id": 38014,
          "label": "Pre Test MCQs",
          "title": "Pre Test MCQs",
          "type": "Practice Test",
          "code": null,
          "displayType": [
            "Display",
            "Filter",
            "Progress"
          ]
        }
      ],
      "score": null
    },
    {
      "id": 104867,
      "versionId": 1,
      "blockId": null,
      "type": "MCQ",
      "parentId": null,
      "recordType": "ITEM",
      "content": {
        "stem": {
          "text": "Mr. Jack enjoys grading student essays on his school-issued laptop at a quiet local café. He uses the café’s free open wireless network to connect to the school’s server and upload the grades.\n\nWhich of the following ethical principles are most at risk?"
        }
      },
      "metadata": {
        "type": "MCQ",
        "ui_type": "pre-test post-test question",
        "language": "en-US",
        "position": 23,
        "sourceId": 9023
      },
      "scoring": {
        "type": "EXACT_MATCH",
        "points": 1,
        "answerKey": [
          {
            "points": 1,
            "choiceId": "9a3d7c1a-33b1-4339-817a-28bc6f2b9d82",
            "isCorrect": true
          },
          {
            "points": 0,
            "choiceId": "6ce9c914-ccdb-492d-8993-6eafa7312d48",
            "isCorrect": false
          },
          {
            "points": 0,
            "choiceId": "99fe5251-e87e-482e-9f23-96f101686306",
            "isCorrect": false
          }
        ],
        "selection": {
          "max": 1,
          "min": 1
        }
      },
      "feedback": [
        {
          "type": "STATIC",
          "choiceId": "9a3d7c1a-33b1-4339-817a-28bc6f2b9d82",
          "detailed": {
            "text": "Using a nonsecure public wireless connection to access student records puts confidential educational data at risk of interception. Educators must take appropriate and reasonable measures to safeguard student information when using technology, including using secure Internet connections."
          },
          "language": "en-US"
        }
      ],
      "response": {
        "type": "SINGLE_CHOICE",
        "choices": [
          {
            "id": "9a3d7c1a-33b1-4339-817a-28bc6f2b9d82",
            "text": "Taking reasonable measures to maintain the confidentiality of student educational records",
            "numFirstSelections": 0
          },
          {
            "id": "6ce9c914-ccdb-492d-8993-6eafa7312d48",
            "text": "Maintaining appropriate professional boundaries with students",
            "numFirstSelections": 0
          },
          {
            "id": "99fe5251-e87e-482e-9f23-96f101686306",
            "text": "Ensuring that all students are treated fairly in the grading process",
            "numFirstSelections": 0
          }
        ],
        "shuffle": false,
        "instruction": "Choose the best answer from the following options."
      },
      "tags": [
        {
          "id": 38014,
          "label": "Pre Test MCQs",
          "title": "Pre Test MCQs",
          "type": "Practice Test",
          "code": null,
          "displayType": [
            "Display",
            "Filter",
            "Progress"
          ]
        }
      ],
      "score": null
    },
    {
      "id": 104868,
      "versionId": 1,
      "blockId": null,
      "type": "MCQ",
      "parentId": null,
      "recordType": "ITEM",
      "content": {
        "stem": {
          "text": "Ms. Blazak’s fellow teacher, Mr. Carris, shows her an expense form that he submitted for travel reimbursement from the school. He admits to Ms. Blazak that many of the expenses were for personal travel and that he misrepresented them on the form.\n\nWhich of the following principles for professional educators is most important for Ms. Blazak to consider in responding to the situation?"
        }
      },
      "metadata": {
        "type": "MCQ",
        "ui_type": "pre-test post-test question",
        "language": "en-US",
        "position": 24,
        "sourceId": 9024
      },
      "scoring": {
        "type": "EXACT_MATCH",
        "points": 1,
        "answerKey": [
          {
            "points": 0,
            "choiceId": "d2da3ab8-5270-46ce-8229-213de4e43eb0",
            "isCorrect": false
          },
          {
            "points": 0,
            "choiceId": "bac332b3-5300-4ef4-8dfd-d4ae18eaa4e8",
            "isCorrect": false
          },
          {
            "points": 1,
            "choiceId": "db9a793c-2656-4852-8f84-02bfe8ddacfd",
            "isCorrect": true
          }
        ],
        "selection": {
          "max": 1,
          "min": 1
        }
      },
      "feedback": [
        {
          "type": "STATIC",
          "choiceId": "db9a793c-2656-4852-8f84-02bfe8ddacfd",
          "detailed": {
            "text": "Falsifying financial records is a serious ethical breach. Educators have a responsibility to uphold the code of ethics and to act when they observe a colleague in an ethically compromising situation. Ignoring misrepresentation undermines the integrity of the profession and the public trust placed in educators."
          },
          "language": "en-US"
        }
      ],
      "response": {
        "type": "SINGLE_CHOICE",
        "choices": [
          {
            "id": "d2da3ab8-5270-46ce-8229-213de4e43eb0",
            "text": "Respecting the privacy of a colleague's financial decisions",
            "numFirstSelections": 0
          },
          {
            "id": "bac332b3-5300-4ef4-8dfd-d4ae18eaa4e8",
            "text": "Maintaining civility in one’s interactions with colleagues when differences of opinion arise",
            "numFirstSelections": 0
          },
          {
            "id": "db9a793c-2656-4852-8f84-02bfe8ddacfd",
            "text": "Maintaining fidelity to the code of professional ethics when a colleague is in an ethically risky situation",
            "numFirstSelections": 0
          }
        ],
        "shuffle": false,
        "instruction": "Choose the best answer from the following options."
      },
      "tags": [
        {
          "id": 38014,
          "label": "Pre Test MCQs",
          "title": "Pre Test MCQs",
          "type": "Practice Test",
          "code": null,
          "displayType": [
            "Display",
            "Filter",
            "Progress"
          ]
        }
      ],
      "score": null
    },
    {
      "id": 104869,
      "versionId": 1,
      "blockId": null,
      "type": "MCQ",
      "parentId": null,
      "recordType": "ITEM",
      "content": {
        "stem": {
          "text": "Mr. Smith overhears a colleague making a disparaging comment about a new teacher’s accent.\n\nWhich of the following actions is most appropriate for Mr. Smith to take?"
        }
      },
      "metadata": {
        "type": "MCQ",
        "ui_type": "pre-test post-test question",
        "language": "en-US",
        "position": 25,
        "sourceId": 9025
      },
      "scoring": {
        "type": "EXACT_MATCH",
        "points": 1,
        "answerKey": [
          {
            "points": 0,
            "choiceId": "c65c86a4-2b5a-474b-bc4d-22ac404be9f9",
            "isCorrect": false
          },
          {
            "points": 1,
            "choiceId": "6bc37093-9225-4d59-ac5d-ae384a565cf3",
            "isCorrect": true
          },
          {
            "points": 0,
            "choiceId": "0e8a94b1-8462-48d6-b500-04e600200ff6",
            "isCorrect": false
          }
        ],
        "selection": {
          "max": 1,
          "min": 1
        }
      },
      "feedback": [
        {
          "type": "STATIC",
          "choiceId": "6bc37093-9225-4d59-ac5d-ae384a565cf3",
          "detailed": {
            "text": "Professional educators must refrain from discriminatory or disparaging behavior and must address it when observed. In this situation, seeking clarification directly from the colleague is the appropriate first step—it opens dialogue, allows for resolution, and helps prevent the development of a discriminatory or intimidating culture."
          },
          "language": "en-US"
        }
      ],
      "response": {
        "type": "SINGLE_CHOICE",
        "choices": [
          {
            "id": "c65c86a4-2b5a-474b-bc4d-22ac404be9f9",
            "text": "Take no action because the colleague holds a leadership role.",
            "numFirstSelections": 0
          },
          {
            "id": "6bc37093-9225-4d59-ac5d-ae384a565cf3",
            "text": "Address the comment directly with the colleague in a professional manner.",
            "numFirstSelections": 0
          },
          {
            "id": "0e8a94b1-8462-48d6-b500-04e600200ff6",
            "text": "Report the comment to the principal without discussing it with the colleague first.",
            "numFirstSelections": 0
          }
        ],
        "shuffle": false,
        "instruction": "Choose the best answer from the following options."
      },
      "tags": [
        {
          "id": 38014,
          "label": "Pre Test MCQs",
          "title": "Pre Test MCQs",
          "type": "Practice Test",
          "code": null,
          "displayType": [
            "Display",
            "Filter",
            "Progress"
          ]
        }
      ],
      "score": null
    },
    {
      "id": 104870,
      "versionId": 1,
      "blockId": null,
      "type": "MCQ",
      "parentId": null,
      "recordType": "ITEM",
      "content": {
        "stem": {
          "text": "Ms. Rodriguez, a high school teacher, uses a generative AI tool to create discussion prompts and write welcome messages for her class’s homepage within the learning management system. She reviews and edits all AI-generated content before posting. A parent emails asking whether Ms. Rodriguez writes all the posts herself.\nWhich of the following is the most ethically sound response for Ms. Rodriguez?"
        }
      },
      "metadata": {
        "type": "MCQ",
        "ui_type": "pre-test post-test question",
        "language": "en-US",
        "position": 26,
        "sourceId": 9026
      },
      "scoring": {
        "type": "EXACT_MATCH",
        "points": 1,
        "answerKey": [
          {
            "points": 0,
            "choiceId": "03d0e26c-9db5-4150-acce-f12a9c99f0f3",
            "isCorrect": false
          },
          {
            "points": 0,
            "choiceId": "883dfbb3-72e4-49cd-aaf8-8e74da4d7911",
            "isCorrect": false
          },
          {
            "points": 1,
            "choiceId": "f8c052f0-dea0-44a3-a809-ccdc650b5b24",
            "isCorrect": true
          }
        ],
        "selection": {
          "max": 1,
          "min": 1
        }
      },
      "feedback": [
        {
          "type": "STATIC",
          "choiceId": "f8c052f0-dea0-44a3-a809-ccdc650b5b24",
          "detailed": {
            "text": "Ethical practice requires transparency about how AI is used. Ms. Rodriguez should disclose AI use while clarifying that she exercises professional judgment and oversight. This builds trust with students’ families and aligns with expectations for openness and accountability."
          },
          "language": "en-US"
        }
      ],
      "response": {
        "type": "SINGLE_CHOICE",
        "choices": [
          {
            "id": "03d0e26c-9db5-4150-acce-f12a9c99f0f3",
            "text": "Telling the parent that she writes all content herself, since she reviews and approves everything",
            "numFirstSelections": 0
          },
          {
            "id": "883dfbb3-72e4-49cd-aaf8-8e74da4d7911",
            "text": "Explaining that many teachers use AI tools now and that district policy permits their use",
            "numFirstSelections": 0
          },
          {
            "id": "f8c052f0-dea0-44a3-a809-ccdc650b5b24",
            "text": "Describing her role in reviewing, approving, and aligning posts with instructional goals",
            "numFirstSelections": 0
          }
        ],
        "shuffle": false,
        "instruction": "Choose the best answer from the following options."
      },
      "tags": [
        {
          "id": 38014,
          "label": "Pre Test MCQs",
          "title": "Pre Test MCQs",
          "type": "Practice Test",
          "code": null,
          "displayType": [
            "Display",
            "Filter",
            "Progress"
          ]
        }
      ],
      "score": null
    },
    {
      "id": 104871,
      "versionId": 1,
      "blockId": null,
      "type": "MCQ",
      "parentId": null,
      "recordType": "ITEM",
      "content": {
        "stem": {
          "text": "Ms. Carter, a first-year teacher, is approached by a student who reports having a severe food allergy. When Ms. Carter checks the student's records, she finds no formal documentation on file. She wants to take the concern seriously but is unsure whether to act on her own or wait until official documentation is provided.\n\nWhich of the following actions best aligns with ethical responsibilities and professional conduct?"
        }
      },
      "metadata": {
        "type": "MCQ",
        "ui_type": "pre-test post-test question",
        "language": "en-US",
        "position": 27,
        "sourceId": 9027
      },
      "scoring": {
        "type": "EXACT_MATCH",
        "points": 1,
        "answerKey": [
          {
            "points": 0,
            "choiceId": "7f43aa08-6644-4535-b268-0052ef451dbf",
            "isCorrect": false
          },
          {
            "points": 1,
            "choiceId": "685e32b3-e9dc-44f8-9f99-3bc1b1318ba7",
            "isCorrect": true
          },
          {
            "points": 0,
            "choiceId": "5598d099-4a22-41be-96c8-2fc2578ba2ab",
            "isCorrect": false
          }
        ],
        "selection": {
          "max": 1,
          "min": 1
        }
      },
      "feedback": [
        {
          "type": "STATIC",
          "choiceId": "685e32b3-e9dc-44f8-9f99-3bc1b1318ba7",
          "detailed": {
            "text": "Ensuring student welfare is a primary ethical responsibility of the professional educator. When a student reports a potentially life-threatening condition, the educator must act promptly to mitigate risk, even before formal documentation is in place. By informing appropriate school personnel, the teacher demonstrates transparency in actions and communications and promotes solution discovery by connecting the student to proper resources and officials rather than handling the issue alone. The teacher also honors the boundaries of their role by recognizing that managing a student’s medical condition exceeds their individual scope."
          },
          "language": "en-US"
        }
      ],
      "response": {
        "type": "SINGLE_CHOICE",
        "choices": [
          {
            "id": "7f43aa08-6644-4535-b268-0052ef451dbf",
            "text": "Remove potential allergens from classroom activities to address the concern as quickly as possible.",
            "numFirstSelections": 0
          },
          {
            "id": "685e32b3-e9dc-44f8-9f99-3bc1b1318ba7",
            "text": "Inform appropriate school personnel of the student’s reported allergy and follow established procedures to ensure the student’s safety while documentation is obtained.",
            "numFirstSelections": 0
          },
          {
            "id": "5598d099-4a22-41be-96c8-2fc2578ba2ab",
            "text": "Explain to the student that accommodations require formal documentation and recommend that the student’s family contact the school to begin the process.",
            "numFirstSelections": 0
          }
        ],
        "shuffle": false,
        "instruction": "Choose the best answer from the following options."
      },
      "tags": [
        {
          "id": 38014,
          "label": "Pre Test MCQs",
          "title": "Pre Test MCQs",
          "type": "Practice Test",
          "code": null,
          "displayType": [
            "Display",
            "Filter",
            "Progress"
          ]
        }
      ],
      "score": null
    },
    {
      "id": 104872,
      "versionId": 1,
      "blockId": null,
      "type": "MCQ",
      "parentId": null,
      "recordType": "ITEM",
      "content": {
        "stem": {
          "text": "Several students who participate in school athletics fail a teacher’s course. The teacher is encouraged by school administrators to assign passing grades so that the students remain eligible for sports participation.\n\nWhich of the following actions is most appropriate for the teacher to take?"
        }
      },
      "metadata": {
        "type": "MCQ",
        "ui_type": "pre-test post-test question",
        "language": "en-US",
        "position": 28,
        "sourceId": 9028
      },
      "scoring": {
        "type": "EXACT_MATCH",
        "points": 1,
        "answerKey": [
          {
            "points": 0,
            "choiceId": "f2ae9b87-7f75-4af4-a6ca-a1e50f153488",
            "isCorrect": false
          },
          {
            "points": 0,
            "choiceId": "7982e89e-7c07-4ef0-affe-8ea18c80aa3d",
            "isCorrect": false
          },
          {
            "points": 1,
            "choiceId": "c95174d1-dc46-4c83-9f6b-15b23f8c8525",
            "isCorrect": true
          }
        ],
        "selection": {
          "max": 1,
          "min": 1
        }
      },
      "feedback": [
        {
          "type": "STATIC",
          "choiceId": "c95174d1-dc46-4c83-9f6b-15b23f8c8525",
          "detailed": {
            "text": "Changing grades to misrepresent student performance or to give certain students an unfair advantage is unethical. Educators must maintain objectivity and neutrality in grading.\n\nIt is inappropriate for an educator to change some students’ grades in a manner that misrepresents the performance of those students or that gives those students an unfair advantage over their classmates. Educators should also ask themselves if there was a way to have dealt with this situation proactively during the term, which would have given them a broader set of appropriate options to help the student athletes and any other underperforming students."
          },
          "language": "en-US"
        }
      ],
      "response": {
        "type": "SINGLE_CHOICE",
        "choices": [
          {
            "id": "f2ae9b87-7f75-4af4-a6ca-a1e50f153488",
            "text": "Provide additional extra credit opportunities only to the students participating in athletics.",
            "numFirstSelections": 0
          },
          {
            "id": "7982e89e-7c07-4ef0-affe-8ea18c80aa3d",
            "text": "Assign passing grades to students whose current grades are close to the passing threshold.",
            "numFirstSelections": 0
          },
          {
            "id": "c95174d1-dc46-4c83-9f6b-15b23f8c8525",
            "text": "Assign students the grades they have earned based on established academic criteria.",
            "numFirstSelections": 0
          }
        ],
        "shuffle": false,
        "instruction": "Choose the best answer from the following options."
      },
      "tags": [
        {
          "id": 38014,
          "label": "Pre Test MCQs",
          "title": "Pre Test MCQs",
          "type": "Practice Test",
          "code": null,
          "displayType": [
            "Display",
            "Filter",
            "Progress"
          ]
        }
      ],
      "score": null
    },
    {
      "id": 104873,
      "versionId": 1,
      "blockId": null,
      "type": "MCQ",
      "parentId": null,
      "recordType": "ITEM",
      "content": {
        "stem": {
          "text": "Ms. Gomez, a fifth-grade teacher, relaxes after school hours by writing a blog focused on the challenges of balancing her family life with her work life.\n\nWhich of the following best describes how Ms. Gomez’s blog is consistent with best practices for professional educators?"
        }
      },
      "metadata": {
        "type": "MCQ",
        "ui_type": "pre-test post-test question",
        "language": "en-US",
        "position": 29,
        "sourceId": 9029
      },
      "scoring": {
        "type": "EXACT_MATCH",
        "points": 1,
        "answerKey": [
          {
            "points": 0,
            "choiceId": "99527e8a-d9ef-49ff-ba85-f65932f8eb9a",
            "isCorrect": false
          },
          {
            "points": 1,
            "choiceId": "afa1a5fb-6519-422f-8999-74590124b193",
            "isCorrect": true
          },
          {
            "points": 0,
            "choiceId": "f9c2c538-17f2-4dce-8331-e8fa2b8d69d1",
            "isCorrect": false
          }
        ],
        "selection": {
          "max": 1,
          "min": 1
        }
      },
      "feedback": [
        {
          "type": "STATIC",
          "choiceId": "afa1a5fb-6519-422f-8999-74590124b193",
          "detailed": {
            "text": "Professional educators are not required to avoid all electronic and public communications, but they do need to keep professional principles in mind. In her blog posts, Ms. Gomez avoids comments that might reveal confidential or personal information about students, jeopardize student safety or welfare, or cast herself or the profession in a negative light."
          },
          "language": "en-US"
        }
      ],
      "response": {
        "type": "SINGLE_CHOICE",
        "choices": [
          {
            "id": "99527e8a-d9ef-49ff-ba85-f65932f8eb9a",
            "text": "It is written on her own time, not school time.",
            "numFirstSelections": 0
          },
          {
            "id": "afa1a5fb-6519-422f-8999-74590124b193",
            "text": "She is careful about the appropriateness and subject matter of her comments.",
            "numFirstSelections": 0
          },
          {
            "id": "f9c2c538-17f2-4dce-8331-e8fa2b8d69d1",
            "text": "Blogs are public expressions of opinion, and her blog deals with her role as a teacher.",
            "numFirstSelections": 0
          }
        ],
        "shuffle": false,
        "instruction": "Choose the best answer from the following options."
      },
      "tags": [
        {
          "id": 38014,
          "label": "Pre Test MCQs",
          "title": "Pre Test MCQs",
          "type": "Practice Test",
          "code": null,
          "displayType": [
            "Display",
            "Filter",
            "Progress"
          ]
        }
      ],
      "score": null
    },
    {
      "id": 104874,
      "versionId": 1,
      "blockId": null,
      "type": "MCQ",
      "parentId": null,
      "recordType": "ITEM",
      "content": {
        "stem": {
          "text": "Principal Tucker is evaluating situations in which various teachers in her school have changed students’ final course grades.\n\nWhich of the following is most likely to be an acceptable justification for changing a student’s grade?"
        }
      },
      "metadata": {
        "type": "MCQ",
        "ui_type": "pre-test post-test question",
        "language": "en-US",
        "position": 30,
        "sourceId": 9030
      },
      "scoring": {
        "type": "EXACT_MATCH",
        "points": 1,
        "answerKey": [
          {
            "points": 1,
            "choiceId": "6fec8c8f-3362-4856-ba60-ee0887500e05",
            "isCorrect": true
          },
          {
            "points": 0,
            "choiceId": "b0bb4da8-840e-4d81-a15d-e48adbe9369b",
            "isCorrect": false
          },
          {
            "points": 0,
            "choiceId": "3751b5f9-8276-427a-b71c-ea5184fc2f59",
            "isCorrect": false
          }
        ],
        "selection": {
          "max": 1,
          "min": 1
        }
      },
      "feedback": [
        {
          "type": "STATIC",
          "choiceId": "6fec8c8f-3362-4856-ba60-ee0887500e05",
          "detailed": {
            "text": "Correcting a student’s grade due to a verified error in a test item is an appropriate and ethically sound action. In this case, the instructor identified a flaw in an assessment that improperly affected the student’s score. Adjusting the grade ensures that it accurately reflects the student’s true level of performance."
          },
          "language": "en-US"
        }
      ],
      "response": {
        "type": "SINGLE_CHOICE",
        "choices": [
          {
            "id": "6fec8c8f-3362-4856-ba60-ee0887500e05",
            "text": "The instructor discovered an error in a test item on the midterm exam that affected the student’s grade.",
            "numFirstSelections": 0
          },
          {
            "id": "b0bb4da8-840e-4d81-a15d-e48adbe9369b",
            "text": "The student demonstrated a positive change in study habits in response to the teacher’s feedback and could use the reinforcement of a better grade.",
            "numFirstSelections": 0
          },
          {
            "id": "3751b5f9-8276-427a-b71c-ea5184fc2f59",
            "text": "The teacher changed a grade because the school testing coordinator requested evidence of student improvement in the course to help the school qualify for a grant.",
            "numFirstSelections": 0
          }
        ],
        "shuffle": false,
        "instruction": "Choose the best answer from the following options."
      },
      "tags": [
        {
          "id": 38014,
          "label": "Pre Test MCQs",
          "title": "Pre Test MCQs",
          "type": "Practice Test",
          "code": null,
          "displayType": [
            "Display",
            "Filter",
            "Progress"
          ]
        }
      ],
      "score": null
    }
  ],
  "examName": "Pre Test Items",
  "sessionSubType": "PRACTICE_TEST"
}